import React from "react";
import Relay from "react-relay";
import {defineMessages, injectIntl} from "react-intl";
import { Form } from 'formsy-react-components';
import LoadingButton from '../../../../fw/LoadingButton.react';
import Expression from '../../../../expression/Expression.react';
import PropTypes from "prop-types";
import {safeJSONparse} from "../../../../../common/util/safeJSONparse";

export const messages = defineMessages({
    save: {id: 'IFrameEdit.save', 'defaultMessage': 'Save Addon configuration'},
    name: {id: 'JSAction.name', 'defaultMessage': 'Name'},
    nameDesc: {id: 'JSAction.nameDesc', 'defaultMessage': 'Insert a name which will be displayed on the button.'},
    description: {id: 'JSAction.description', 'defaultMessage': 'Description'},
    descriptionDesc: {id: 'JSAction.descriptionDesc', 'defaultMessage': 'Insert description of button.'},
    javaScript: {id: 'JSAction.javaScript', 'defaultMessage': 'JavaScript'},
    javaScriptDesc: {id: 'JSAction.javaScriptDesc', 'defaultMessage': 'Write a JavaScript snippet which will be invoked after clicking on button.'},
    icon: {id: 'JSAction.icon', 'defaultMessage': 'Icon'},
    iconDesc: {id: 'JSAction.iconDesc', 'defaultMessage': 'Icon on button. Choose one from https://fontawesome.com/v4.7.0/icons/'},
    connectedChannel: {id: 'JSAction.connectedChannel', 'defaultMessage': 'Connected application'},
    connectedChannelDesc: {id: 'JSAction.connectedChannelDesc', 'defaultMessage': 'Select connected channel. This channel will be available in JavaScript.'},
});

export const handlerName = "js-action";

class JSActionEdit extends React.Component {

    static propTypes = {
        channelAddon: PropTypes.object.isRequired,
        intl: PropTypes.object,
        save: PropTypes.func,
    };

    constructor(props) {
        super(props);

        let channelAddon = this.props.channelAddon;
        let isOk = true;
        let options = safeJSONparse(channelAddon.options);

        this.state = {
            canSubmit: isOk,
            mapping: options,
        };
    }

    collectMappableFields(channelAddon) {
        let result = [
            {
                key: 'name',
                name: this.props.intl.formatMessage(messages.name),
                description: this.props.intl.formatMessage(messages.nameDesc),
            },
            {
                key: 'description',
                name: this.props.intl.formatMessage(messages.description),
                description: this.props.intl.formatMessage(messages.descriptionDesc),
            },
            {
                key: 'icon',
                name: this.props.intl.formatMessage(messages.icon),
                description: this.props.intl.formatMessage(messages.iconDesc)
            },
            {
                key: 'javaScript',
                name: this.props.intl.formatMessage(messages.javaScript),
                description: this.props.intl.formatMessage(messages.javaScriptDesc),
                textarea: true,
            }
        ];
        return result;
    }

    enableButton = () => {
        this.setState({
            canSubmit: true
        });
    };

    disableButton = () => {
        this.setState({
            canSubmit: false
        });
    };

    add = () => {
        return this.props.save(this.state.mapping);
    };

    render() {
        return (<Form
            onInvalid={this.disableButton}
            onValid={this.enableButton}
            onValidSubmit={this.add}
        >
                <table className="table">
                    <tbody>
                    {this.collectMappableFields(this.props.channelAddon).map((row) => {
                        return (
                            <tr key={row.key}>
                                <td>{row.name}</td>
                                <td>
                                    <Expression afterChange={(value) => {
                                        let newMapping = {...this.state.mapping};
                                        newMapping[row.key] = value;

                                        this.setState({
                                            mapping: newMapping,
                                        });

                                    }} expression={this.state.mapping[row.key]} multiLine={row.textarea}/>
                                    {row.description ? <p><small>{row.description}</small></p> : null}
                                </td>
                            </tr>
                        );
                    })}
                    </tbody>
                </table>

            <LoadingButton className="btn btn-primary"
                           disabled={!this.state.canSubmit}
                           type="submit">{this.props.intl.formatMessage(messages.save)}</LoadingButton>
        </Form>);
    }
}

export default Relay.createContainer(injectIntl(JSActionEdit), {
    initialVariables: {
    },
    prepareVariables (variables) {
        return variables;
    },
    fragments: {
        channelAddon: () => {
            return Relay.QL`
                fragment on ChannelAddon {
                    id,
                    realId,
                    name,
                    options,
                    channel {
                        id,
                        name,
                        organisation_id,
                    },
                    sourceDef {
                        id,
                        channelEntityDefs(first: 100) {
                            edges {
                                node {
                                    id,
                                    usedFieldDefs(first: 1000) {
                                        edges {
                                            node {
                                                id,
                                                realId,
                                                name,
                                                key,
                                                type,
                                                entityDef {
                                                    id,
                                                    key,
                                                    name
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }`;
        }

    }

});
